"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tabs = void 0;
var react_1 = __importStar(require("react"));
var useDidUpdateEffect_1 = require("../../../hooks/useDidUpdateEffect");
var Tabs_style_1 = require("./Tabs.style");
exports.Tabs = react_1.default.forwardRef(function Tabs(_a, ref) {
    var options = _a.options, onSelect = _a.onSelect, _b = _a.disabled, disabled = _b === void 0 ? false : _b, _c = _a.skeleton, skeleton = _c === void 0 ? false : _c, defaultTab = _a.defaultTab;
    var indexDefault = react_1.useMemo(function () { return options.findIndex(function (i) { return i.id === defaultTab; }); }, [options]);
    var _d = react_1.useState(indexDefault === -1 ? 0 : indexDefault), selectTabIndex = _d[0], setSelectTabIndex = _d[1];
    var _e = react_1.useState({}), selectorStyle = _e[0], setSelectorStyle = _e[1];
    var tabRefs = react_1.useRef({});
    var tabContainerRef = react_1.useRef();
    react_1.useImperativeHandle(ref, function () { return ({
        setTab: function (tab) {
            var indexTab = options.findIndex(function (i) { return i.id === tab; });
            if (indexTab !== -1) {
                setSelectTabIndex(indexTab);
            }
        },
    }); });
    useDidUpdateEffect_1.useDidUpdateEffect(function () {
        onSelect(options[selectTabIndex]);
    }, [selectTabIndex]);
    var setTab = react_1.useCallback(function setTab(item, indexTab) {
        setSelectTabIndex(function (currentSelect) {
            if (currentSelect !== indexTab) {
                return indexTab;
            }
            return currentSelect;
        });
    }, []);
    function onSetTab(item, i) {
        setSelectorPosition(item, i);
        return !disabled && !skeleton && setTab(item, i);
    }
    react_1.useEffect(function () {
        setSelectorPosition(options[selectTabIndex], selectTabIndex);
    }, []);
    function setSelectorPosition(tab, i) {
        var _a = tabRefs.current[i], clientWidth = _a.clientWidth, clientHeight = _a.clientHeight, offsetLeft = _a.offsetLeft, offsetTop = _a.offsetTop;
        setSelectorStyle({
            width: clientWidth + "px",
            height: clientHeight + "px",
            left: offsetLeft + "px",
            top: offsetTop + "px",
            transition: '200ms all ease-in-out',
        });
        scrollToLeft(tabContainerRef.current, offsetLeft - clientWidth / 2 + clientWidth / 2, 100);
    }
    function scrollToLeft(element, to, duration) {
        var start = element.scrollLeft;
        var change = to - start;
        var currentTime = 0;
        var increment = 20;
        var easeInOutQuad = function (t, b, c, d) {
            t /= d / 2;
            if (t < 1) {
                return (c / 2) * t * t + b;
            }
            t -= 1;
            return (-c / 2) * (t * (t - 2) - 1) + b;
        };
        var animateScroll = function () {
            currentTime += increment;
            var val = easeInOutQuad(currentTime, start, change, duration);
            element.scrollLeft = val;
            if (currentTime < duration) {
                setTimeout(animateScroll, increment);
            }
        };
        animateScroll();
    }
    return (react_1.default.createElement(Tabs_style_1.TabsStyle, null,
        react_1.default.createElement("div", { className: "tabs", ref: tabContainerRef },
            react_1.default.createElement("div", { className: "tab-selector", "data-cy": "tab-selector", style: selectorStyle }),
            options &&
                options.map(function (item, i) { return (react_1.default.createElement(Tab, { key: i, index: i, item: item, onSetTab: onSetTab, selectTabIndex: selectTabIndex, skeleton: skeleton, tabRefs: tabRefs })); }))));
});
function Tab(_a) {
    var index = _a.index, item = _a.item, onSetTab = _a.onSetTab, selectTabIndex = _a.selectTabIndex, skeleton = _a.skeleton, tabRefs = _a.tabRefs;
    return (react_1.default.createElement("div", { key: index, "data-index": index, "data-cy": "tab-" + item.id, "data-testid": "tab-" + item.id, className: "tab " + (index === selectTabIndex && 'active'), onClick: function () { return onSetTab(item, index); }, ref: function (_ref) {
            tabRefs.current[index] = _ref;
        } },
        react_1.default.createElement("span", { className: "" + (skeleton && 'skeleton') }, item.name)));
}
//# sourceMappingURL=Tabs.js.map